import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import cn from "classnames";

interface Props {
  className?: string;
  style?: React.CSSProperties;
  title?: string;
  onClick?: () => void;
  color?: string;
  label: string;
  icon?: JSX.Element;
  enabled?: boolean;
  selected?: boolean;
}
export const FilterOption = ({
  label,
  className,
  style,
  title,
  onClick,
  color,
  icon,
  enabled = true,
  selected = false,
}: Props) => {
  return (
    <span
      role="button"
      tabIndex={enabled ? 0 : -1}
      aria-pressed={selected}
      aria-disabled={!enabled}
      title={title}
      style={style}
      className={cn(`d-flex my-auto ${className}`, {
        "text-secondary": !enabled,
        "text-primary": selected,
        pointer: enabled,
      })}
      onClick={enabled ? onClick : () => null}
      onKeyDown={(e) => {
        if (!enabled || !onClick) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {icon ? (
        icon
      ) : (
        <FontAwesomeIcon
          className={cn("mx-2 my-auto", {
            "text-secondary": !enabled,
            "text-primary": selected,
            pointer: enabled,
          })}
          icon={["fas", "comments"]}
          size="lg"
          color={!selected ? "#E4E4E4" : color}
        />
      )}

      <p className="must-hide my-auto"> {label}</p>
    </span>
  );
};
